import { hashKey, useQuery } from '@tanstack/react-query';

import { CompanyCriteria } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface ImportersMeta {
  total: number;
}

export const useImportersMeta = (filters: CompanyCriteria['filters']) =>
  useQuery({
    queryKey: ['importers-meta', hashKey([filters])],
    queryFn: async (filters): Promise<ImportersMeta> => {
      try {
        const result = await apiClient.importer.retrieveImportersMetadata.mutation({ body: filters ?? {} });
        if (result.status !== 200) throw result.body;

        return { total: result.body.metadata.total };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch importers metadata');
      }
    },
    placeholderData: {
      total: 0,
    },
  });
